import clsx from "clsx"
import { NpIcon } from "src/components/np-design/components/NpIcon"
import { Img } from "src/components/unstyled/Img"
import { CouponData } from "src/data/product-details/types"
import { useIsClient } from "src/hooks/useIsClient"
import { toImageCdnUrl } from "src/utilities/images"
import { TileDiscountHeader } from "./TileDiscountHeader"

export type TileProps = {
  name: string
  image: string
  available: boolean | undefined
  regularPrice: number | undefined
  discount: number | undefined
  coupon: CouponData | undefined
  showTileDiscountHeader: boolean
  variationsAreNotColors: boolean | undefined
  selected: boolean | undefined
  onClick: () => void
}

export const Tile = ({
  name,
  image,
  available,
  regularPrice,
  discount,
  coupon,
  showTileDiscountHeader,
  variationsAreNotColors,
  selected,
  onClick,
}: TileProps) => {
  const isClient = useIsClient()

  const label = available ? name : `${name} (nicht verfügbar)`

  return (
    <li className="xs:w-24 grid aspect-square w-21 grid-cols-1 justify-items-center gap-2">
      <div className="w-full rounded-lg">
        {showTileDiscountHeader && (
          <TileDiscountHeader discount={discount} coupon={coupon} regularPrice={regularPrice} available={available} />
        )}

        <button
          type="button"
          title={label}
          aria-label={label}
          onClick={onClick}
          className={clsx(
            "relative flex aspect-square w-full items-center justify-center rounded-lg border bg-white transition-colors hover:transition-none",
            {
              "border-current": available && selected && isClient,
              "border-gray-200 hover:border-gray-400": available && !selected,
              "border-elvent-unavailable": !available && selected,
            },
          )}
        >
          <div
            className={clsx("overflow-hidden rounded-full", {
              "size-full p-2": variationsAreNotColors,
              "xs:size-12 size-10": !variationsAreNotColors,
            })}
          >
            <Img src={toImageCdnUrl(image)} alt={name} className="size-full object-cover" />
          </div>

          {!available && (
            <span className="bg-elvent-unavailable xs:w-[126px] absolute top-1/2 left-1/2 z-10 h-[2px] w-[110px] -translate-x-1/2 -translate-y-1/2 -rotate-45" />
          )}

          {isClient && (
            <NpIcon
              name="check_circle_filled"
              className={clsx("text-np-green xs:size-8 absolute top-0 left-0 size-7", {
                "opacity-0 transition-opacity": !selected,
              })}
            />
          )}

          {regularPrice && <NpIcon name="percent" className="text-np-green xs:size-8 absolute top-0 right-0 size-7" />}
        </button>
      </div>

      <span className="font-product text-center text-sm whitespace-nowrap">{name}</span>
    </li>
  )
}
